// extracted by mini-css-extract-plugin
module.exports = {"steps":"style_steps__2YYCq","submitButton":"style_submitButton__36TC-","arrow":"style_arrow__60eK-"};